import { CustomElement, resolve } from 'aurelia';
import { ScraperReportAdminService } from '../../services';
import template from './scraper-report-admin-panel.html';
import './scraper-report-admin-panel.css';

// Admin-only modal that lists every registered scraper source with when it last produced data,
// so a source that has silently stopped working is easy to spot. Opened from the admin menu; all
// state, the load call and the health/relative-time helpers live in ScraperReportAdminService.
// Read-only: it is a monitoring view, not an editor (use the Sources panel to toggle a source).
export class ScraperReportAdminPanelElement {
  readonly scraperReport: ScraperReportAdminService = resolve(ScraperReportAdminService);
}

export const ScraperReportAdminPanel = CustomElement.define({
  name: 'scraper-report-admin-panel',
  template
}, ScraperReportAdminPanelElement);
